export const AIChatSessionFragment = gql`
  fragment AIChatSessionFragment on AIChatSession {
    id
    chats {
      ...AIAssistantChatFragment
    }
    startedAt
    user {
      ...UserDataFragment
    }
  }
`

/**
 * Fragment for staff AI chat session history list.
 * Contains minimal fields needed for the sidebar list display.
 */
export const StaffAIChatSessionPreviewFragment = gql`
  fragment StaffAIChatSessionPreviewFragment on AIChatSession {
    id
    sessionType
    startedAt
    previewChat {
      id
      question
      questionCreatedAt
    }
  }
`

/**
 * Fragment for loading a full staff AI chat session with all messages.
 * Used when restoring a conversation from history.
 */
export const StaffAIChatSessionWithMessagesFragment = gql`
  fragment StaffAIChatSessionWithMessagesFragment on AIChatSession {
    id
    sessionType
    startedAt
    chats {
      id
      question
      questionCreatedAt
      response
      responseCreatedAt
      citations {
        ...AIChatCitationFragment
      }
    }
  }
`
